/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataSystemExchangeRateRespVo } from './PageDataSystemExchangeRateRespVo';
import {
    PageDataSystemExchangeRateRespVoFromJSON,
    PageDataSystemExchangeRateRespVoFromJSONTyped,
    PageDataSystemExchangeRateRespVoToJSON,
    PageDataSystemExchangeRateRespVoToJSONTyped,
} from './PageDataSystemExchangeRateRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataSystemExchangeRateRespVo
 */
export interface ResponsePageDataSystemExchangeRateRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataSystemExchangeRateRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataSystemExchangeRateRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataSystemExchangeRateRespVo}
     * @memberof ResponsePageDataSystemExchangeRateRespVo
     */
    data?: PageDataSystemExchangeRateRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataSystemExchangeRateRespVo interface.
 */
export function instanceOfResponsePageDataSystemExchangeRateRespVo(value: object): value is ResponsePageDataSystemExchangeRateRespVo {
    return true;
}

export function ResponsePageDataSystemExchangeRateRespVoFromJSON(json: any): ResponsePageDataSystemExchangeRateRespVo {
    return ResponsePageDataSystemExchangeRateRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataSystemExchangeRateRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataSystemExchangeRateRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataSystemExchangeRateRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataSystemExchangeRateRespVoToJSON(json: any): ResponsePageDataSystemExchangeRateRespVo {
    return ResponsePageDataSystemExchangeRateRespVoToJSONTyped(json, false);
}

export function ResponsePageDataSystemExchangeRateRespVoToJSONTyped(value?: ResponsePageDataSystemExchangeRateRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataSystemExchangeRateRespVoToJSON(value['data']),
    };
}

